// extracted by mini-css-extract-plugin
export default {"NowStreaming":"GameWatchLive-module__NowStreaming__R26GI"};